import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Typography, Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppButton } from '../../../../Components/AppButton';
import KenLoader from '../../../../GlobalComponents/KenLoader';
import { getGoalTask } from '../../../../Utils/apiService';
import { formatDate2 } from '../../../../Utils/helperFunctions';
import { useStyles } from '../../styles';
import routes from '../../../../Utils/routes';

const statusColors: { [key: string]: string } = {
  'Not Started': '#5E35B1',
  'In Progress': '#F57C00',
  Completed: '#4CAF50',
  Closed: '#9E9E9E',
  'Upcoming - Requested': '#F57C00',
  'Upcoming - Confirmed': '#5E35B1',
};

const GoalsAndMilestonesData: React.FC = () => {
  const { state } = useLocation();
  const { data, mentorName } = state || { data: {}, mentorName: '' };
  const navigate = useNavigate();

  console.log(JSON.stringify(state), 'data from milestone');

  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [goalTask, setGoalTask] = useState<any>([]);
  const [activeGoal, setActiveGoal] = useState(data?.mileStoneGoals?.[0] || {});

  useEffect(() => {
    const defaultGoalId = data?.mileStoneGoals?.[0]?.id;
    if (defaultGoalId) {
      setLoading(true);
      getGoalTask(defaultGoalId)
        .then((res: any) => {
          setGoalTask(res?.result);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [data]);

  const handleGoalClick = async (goal: any, index: number) => {
    setActiveGoal(goal);
    await getGoalTask(goal?.id).then((res: any) => {
      console.log(res?.result, 'res from goal task');
      setGoalTask(res?.result);
    });
  };

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Box className={classes.BoxContainer}>
          <Box className={classes.BoxSubContainer}>
            <Typography className={classes.milestoneTitle}>Goals & Milestones</Typography>
            <AppButton variant="contained" startIcon={<AddIcon />} className={classes.addMilestoneBtn} onClick={() => navigate(routes.addgoalmilestones)}>
              Add Milestones
            </AppButton>
          </Box>

          <Box className={classes.mainContent}>
            {/* Left Panel */}
            <Grid container spacing={2}>
              <Grid item xs={3.5}>
                <Box className={classes.leftPanel}>
                  <Box className={classes.milestonebar}>
                    <Box className={classes.leftPanelHeader}>
                      <Typography className={classes.milestoneId}>MILESTONE #1</Typography>
                      {/* <Button className={classes.optionsButton}>
                      Options <ExpandMoreIcon />{' '}
                    </Button> */}
                    </Box>

                    <Box className={classes.milestoneTitleContainer}>
                      <Typography className={classes.MilestoneTitle}>{data?.mileStoneName}</Typography>
                      {/* <Typography className={classes.statusText} style={{ color: statusColors[data.status] }}>
                        {data.status}
                      </Typography> */}
                    </Box>
                  </Box>

                  {/* Goal Cards */}
                  <Box sx={{ mt: { xs: '18px', ultraHD: '24px' } }}>
                    {data?.mileStoneGoals?.length > 0 ? (
                      data.mileStoneGoals.map((goal: any, index: number) => (
                        <Box
                          key={goal.id}
                          className={`${classes.goalCard} ${goal.id === activeGoal?.id ? classes.activeGoalCard : classes.inactiveGoalCard}`}
                          onClick={() => handleGoalClick(goal, index)}
                          sx={{ cursor: 'pointer' }}
                        >
                          <Box className={classes.goalCardContainer}>
                            <Typography className={`${classes.goalId} ${goal?.id === activeGoal?.id ? classes.activeGoalId : classes.inactiveGoalId}`}>MILESTONE #1</Typography>
                            <Typography className={classes.goalTitle}>{goal?.goalName}</Typography>
                          </Box>

                          <Box className={classes.goalCardStatusContainer}>
                            <Typography className={classes.goalStatus} style={{ color: statusColors[goal.status] }}>
                              {goal?.status}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box
                        sx={{
                          padding: '20px',
                          textAlign: 'center',
                          color: '#666',
                        }}
                      >
                        <Typography>No milestone goals available</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>

              {/* Right Panel */}
              <Grid item xs={8.5}>
                <Box className={classes.rightPanel}>
                  <Box className={classes.MileStoneBox}>
                    <Box className={classes.rightPanelHeader}>
                      <Typography className={classes.rightPanelTitle}>Goal#{data?.mileStoneGoals?.findIndex((goal: any) => goal.id === activeGoal.id) + 1}</Typography>
                      {/* <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <Button className={classes.optionsButton}>
                        {' '}
                        Goal Options <ExpandMoreIcon />{' '}
                      </Button>
                    </Box> */}
                    </Box>

                    <Box>
                      <Typography className={classes.rightPanelTitle2}>Goal#{data?.mileStoneGoals?.findIndex((goal: any) => goal.id === activeGoal.id) + 1}</Typography>
                    </Box>

                    <Box className={classes.goalInformation}>
                      <Typography className={classes.goalDetailTitle}>{activeGoal.goalName}</Typography>
                      <Typography className={classes.goalDescription}>{activeGoal.description}</Typography>
                    </Box>

                    <Box className={classes.progressSection}>
                      <Box className={classes.progressInfo}>
                        <Typography className={classes.progressText}>
                          PROGRESS:{' '}
                          <Box component={'span'} sx={{ fontSize: { xs: '10.5px', ultraHD: '12px' }, color: '#333333' }}>
                            {activeGoal.goalProgressCurrentValue}%
                          </Box>
                        </Typography>
                        <Typography className={classes.progressText}>
                          GOAL DURATION:{' '}
                          <Box component={'span'} sx={{ fontSize: { xs: '10.5px', ultraHD: '12px' }, color: '#333333' }}>
                            {activeGoal.goalStartDate && activeGoal.goalEndDate && (
                              <>
                                {formatDate2(activeGoal.goalStartDate)} &#8594; {formatDate2(activeGoal.goalEndDate)}
                              </>
                            )}
                          </Box>
                        </Typography>
                        <Typography className={classes.progressText}>
                          LINKED TO:{' '}
                          <Box component={'span'} sx={{ fontSize: { xs: '10.5px', ultraHD: '12px' }, color: '#333333' }}>
                            {mentorName}
                          </Box>
                        </Typography>
                      </Box>
                    </Box>

                    <Box className={classes.goalInformation}>
                      <Typography className={classes.callsTitle}>Call Linked to the Goal</Typography>
                    </Box>

                    <Box className={classes.callsContainer}>
                      {goalTask?.map((call: any, index: number) => (
                        <Box key={call.id} className={classes.callCard}>
                          <Box className={classes.callHeader}>
                            <Typography className={classes.callId}>
                              CALL NO <Box component={"span"} sx={{ fontWeight: 600, }}>#{index + 1}</Box>
                            </Typography>
                            {/* #{index+1}</Typography> */}
                          </Box>

                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography className={classes.callStatus} style={{ color: statusColors[call.status] }}>
                              {call.status}
                            </Typography>
                            <Typography className={classes.callInfo}>CALL INFO: {call?.activityDate}</Typography>

                            {call.recording && <Typography className={classes.recordingLink}>Call recording link: {call.recording}</Typography>}
                          </Box>

                          <Button className={classes.optionsButton}>
                            Call Options <ExpandMoreIcon />
                          </Button>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};

export default GoalsAndMilestonesData;
